<template>
  <div id="app">
    <AdminLayout v-if="isAuthenticated && !isLoginRoute">
      <router-view />
    </AdminLayout>
    <router-view v-else />
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import AdminLayout from '@/components/AdminLayout.vue'
import { config as appConfig } from '@/config'

const route = useRoute()

const isAuthenticated = computed(() => {
  return !!localStorage.getItem(appConfig.auth.tokenKey)
})

const isLoginRoute = computed(() => {
  return route.name === 'login'
})
</script>

<style>
#app {
  min-height: 100vh;
  background-color: #f3f4f6;
}
</style>